export default __webpack_public_path__ + "static/media/ttac3.c2e9a304.svg";